module.exports = __webpack_public_path__ + "img/tfsb5.d4aa7ddc.png";